import { makeStyles } from '@mui/styles';

export default makeStyles(theme => ({
    paper: {
        paddingBottom: `var(--safe-area-inset-bottom)`,
    },
    flexbox: {

        paddingTop: `var(--safe-area-inset-top)`,
        paddingBottom: `var(--safe-area-inset-bottom)`,
        paddingLeft: `var(--safe-area-inset-left)`,
        paddingRight: `var(--safe-area-inset-right)`,
        display:"flex",
        flexDirection:"row",
        justifyContent:"center",
        alignItems:"stretch",
        alignContent:"center"
    }
}));